import React from "react";
import PropTypes from "prop-types";
import Button from "components/common_components/Button";

export const SearchBy = {
    Client: "client",
    Case: "case",
};

const options = [
    { id: SearchBy.Client, label: "Client" },
    { id: SearchBy.Case, label: "Case" },
];

const SearchByToggle = ({ value, onChange }) => (
    <div className="search-by-toggle">
        <span>Search by</span>
        {options.map(({ id, label }) => (
            <Button key={id} secondary small outline={value !== id} onClick={() => value !== id && onChange(id)}>
                {label}
            </Button>
        ))}
    </div>
);

SearchByToggle.propTypes = {
    value: PropTypes.oneOf(Object.values(SearchBy)),
    onChange: PropTypes.func,
};

SearchByToggle.defaultProps = {
    value: SearchBy.Client,
    onChange: () => {},
};

export default SearchByToggle;
